import { removeTrendParams } from "../components/AssetManagement/Overview/Trends/TrendsMobile/helpers/funcs/filterURLRemove";
import {
  removeParamsFromList,
  timeUnitParams,
} from "../components/AssetManagement/Overview/Trends/TrendsMobile/helpers/funcs/timeUnitParams";
import {
  clearFilterMobileDataMap,
  resetMobileFilters,
  setNotesLabelFilter,
  setTrendsMobileData,
} from "../features/trendsSlice";

export const resetOnWorkspaceChange = ({
  dispatch,
  searchParams,
  nextWorkspaceParam,
}: {
  dispatch: any;
  searchParams: URLSearchParams;
  nextWorkspaceParam?: string;
}) => {
  if (nextWorkspaceParam !== undefined) {
    const normalize = (value: string | null | undefined) =>
      (value ?? "")
        .split(",")
        .map((s) => s.trim())
        .filter(Boolean)
        .sort()
        .join(",");

    const currentWorkspace = normalize(searchParams.get("workspace"));
    const nextWorkspace = normalize(nextWorkspaceParam);

    // If the workspace list didn't actually change, don't reset Redux or URL.
    if (currentWorkspace === nextWorkspace) {
      return searchParams;
    }
  }
  // 🔹 Redux resets
  dispatch(setTrendsMobileData(null));
  dispatch(resetMobileFilters());
  dispatch(setNotesLabelFilter(null));
  dispatch(clearFilterMobileDataMap());

  // 🔹 URL cleanup
  let updated = removeTrendParams(searchParams);
  updated = removeParamsFromList(updated, timeUnitParams);

  return updated;
};
